/**
 * Switch modules
 */
export * from './switch';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-buttons/src/switch/index.js
// module id = 1848
// module chunks = 0